import React from "react";
import { Label } from "reactstrap";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

type FieldLabelProps = {
    label?: string;
    hideLabel?: boolean;
    isCheckBox?: boolean;
    required?: boolean;
    optionalIndication?: boolean;
    name: string;
};

const FieldLabel = ({
    hideLabel,
    isCheckBox,
    label,
    optionalIndication,
    required,
    name,
}: FieldLabelProps) => {
    const { t } = useGranite();

    if (!label) {
        return null;
    }
    return (
        <Label for={name} hidden={hideLabel} check={isCheckBox}>
            {label}{" "}
            {required
                ? "*"
                : optionalIndication && (
                      <span className="font-italic small">
                          {t("form.input.optional")}
                      </span>
                  )}
        </Label>
    );
};

export { FieldLabel };
